import { throttle } from 'lodash'

import store from '@/store/index'

const windowFn = throttle(
  function () {
    const innerWH = {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight
    }
    store.dispatch('system/setInnerWH', innerWH)
  },
  1000,
  { leading: false }
)

// 全局监听窗口大小变化事件
window.addEventListener('resize', windowFn)
